<template>
    <fieldset aria-describedby="content-info-text">
        <legend
            v-if="listHeading"
            :id="uniqueId"
            class="legendelement"
        >
            {{ $t(listHeading) }}
        </legend>
        <div role="radiogroup">
            <div
                v-for="option in radioButtonList"
                :key="option.radioValue"
                class="rb-item"
            >
                <div class="radio-button-group">
                    <input
                        :id="option.radioValue"
                        v-model="selectedValue"
                        type="radio"
                        :name="name"
                        :value="option.radioValue"
                        @change="onChange(option)"
                    >
                    <label :for="option.radioValue">{{ getOptionLabelText(option) }}</label>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script lang="ts">
    import { Vue, Component, Prop, Emit, Watch } from "vue-facing-decorator"
    import SimpleRadioButtonModel from "@/models/simpleradiobuttonmodel"

    @Component
    export default class RadioButtonList extends Vue {
        @Prop({ required: true }) radioButtonList!: Array<SimpleRadioButtonModel>
        @Prop({ required: true }) name!: string
        @Prop({ default: '' }) value!: string | number
        @Prop() listHeading: string | undefined

        selectedValue: string | number | null = null

        getOptionLabelText(option: SimpleRadioButtonModel): string {
            // jos labelTextille ei l�yty k��nn�st�, k�ytet��n labelTexti� sellaisenaan
            return this.$t(option.labelText) ?? option.labelText
        }

        @Watch('value', { immediate: true })
        onValueChange(newValue: string | number) {
            this.selectedValue = newValue || null
        }

        @Emit('selectedRadioButton')
        onChange(option: SimpleRadioButtonModel) {
            return option
        }
    }
</script>

<style scoped>
    .legendelement {
        font-size: 1.125rem;
        font-family: Montserrat;
    }

    .radiobuttonelement {
        margin-bottom: 0.5rem;
    }

    .rb-item {
        margin-bottom: 7px;
    }

    div.radio-button-group label {
        vertical-align: super;
        line-height: 22px;
    }

    .dropdownelement {
        margin: 0 0 12px 0;
    }

        .dropdownelement select.error {
            background-color: rgba(158,0,59,0.05);
        }

    .dropdown {
        margin-top: 0.9rem;
        margin-bottom: 1.2rem;
    }

        .dropdown > select {
            width: 100%;
        }

    div > div.dropdown::after {
        position: absolute;
        right: 0.625rem;
        top: 0.75rem;
        filter: invert(10%) sepia(27%) saturate(5527%) hue-rotate(205deg) brightness(96%) contrast(106%);
    }

    button.toggle-item-visibility {
        background: none;
        border: none;
        padding: 0;
        display: flex;
        font-family: Open Sans;
        font-size: 1rem;
        color: var(--Traficom-main-color);
        cursor: pointer;
    }

    .element-with-path-icon::after {
        filter: invert(10%) sepia(27%) saturate(5527%) hue-rotate(205deg) brightness(96%) contrast(106%);
        margin-left: 15px;
    }

    .element-with-path-icon.open::after {
        transform: rotateZ(180deg);
    }

    select {
        background-color: #FFFFFF;
    }
</style>
